/////////////-----------------Service Action------------------///////////
export const GET_VENDORS = "GET_VENDORS";
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS";
export const GET_VENDORS_FAIL = "GET_VENDORS_FAIL";
export const UPDATE_VENDORS_LIST = "UPDATE_VENDORS_LIST";

export const GET_VENDORS_BY_ID = "GET_VENDORS_BY_ID";
export const GET_VENDORS_BY_ID_SUCCESS = "GET_VENDORS_BY_ID_SUCCESS";
export const GET_VENDORS_BY_ID_FAIL = "GET_VENDORS_BY_ID_FAIL";

export const ADD_VENDOR = "ADD_VENDOR";
export const ADD_VENDOR_SUCCESS = "ADD_VENDOR_SUCCESS";
export const ADD_VENDOR_FAIL = "ADD_VENDOR_FAIL";

export const REMOVE_VENDOR = "REMOVE_VENDOR";
export const REMOVE_VENDOR_SUCCESS = "REMOVE_VENDOR_SUCCESS";
export const REMOVE_VENDOR_FAIL = "REMOVE_VENDOR_FAIL";

export const EDIT_VENDOR = "EDIT_VENDOR";
export const EDIT_VENDOR_SUCCESS = "EDIT_VENDOR_SUCCESS";
export const EDIT_VENDOR_FAIL = "EDIT_VENDOR_FAIL";
